import { cards } from '@/mocks/homeData';

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-3">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-100">
              本周热门推荐
            </h2>
            <p className="text-foreground-400 text-sm mt-2">编辑精选 · 品质保证</p>
          </div>
          <a
            href="#ranking"
            onClick={(e) => {
              e.preventDefault();
              const el = document.getElementById('ranking');
              if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-1 text-primary-500 text-sm hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看完整榜单 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
          {cards.map((item) => (
            <div
              key={item.title}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg mb-3 aspect-[2/3] bg-background-200">
                <img
                  src={item.image}
                  alt={`${item.title} - 80s电影网高清在线看`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span className={`px-2 py-0.5 rounded text-xs font-medium whitespace-nowrap ${
                    item.tag === '热播中' ? 'bg-accent-500 text-foreground-50' :
                    item.tag === '新上架' ? 'bg-primary-500 text-background-950' :
                    item.tag === '高分' ? 'bg-accent-400 text-foreground-50' :
                    'bg-secondary-500 text-foreground-50'
                  }`}>
                    {item.tag}
                  </span>
                </div>
                <div className="absolute top-2 right-2">
                  <span className="px-2 py-0.5 rounded text-xs font-bold bg-background-950/70 text-primary-500 whitespace-nowrap">
                    {item.rating}
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-bold text-foreground-100 group-hover:text-primary-500 transition-colors truncate">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-0.5">
                {item.category} · {item.year}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}